'use strict';
import Component from 'gia/Component';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Splide from '@splidejs/splide';
import gsap from 'gsap'
import { ScrollToPlugin } from "../vendor/gsap-bonus-umd/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
import WheelIndicator from 'wheel-indicator';

export default class HomeView extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element;
    this.DOM.cover = this.DOM.view.querySelector('.jsCoverIntro')
    this.DOM.slideshow = this.DOM.cover.querySelector('.splide')
    this.DOM.title = this.DOM.cover.querySelector('.fxTitle')
    this.DOM.cta = this.DOM.cover.querySelector('.jsScrollDown')
    this.classView = 'currentView--home'
    this.slideshows = []
    //! VARS
    this.VARS = {}
    this.VARS.ANIMATING = false
    //! Fns
    this.makeSlideshow()
    this.makeSlideshowIntro()
    this.events()
    //! Launch Intro
    this.prepareIntro()
    this.funcLaunch = this._launch.bind(this)
    this.channels()
  }

  _launch()
  {
    this.intro()
  }

  channels()
  {
    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
  }

  destroy()
  {
      Channels.removeListener('launcher::exit', this.funcLaunch);
  }

  events()
  {
    this.DOM.view.querySelector('.jsScrollDown').addEventListener('click',()=>{
      this.moveToGrid()
    })

    this.indicator = new WheelIndicator({
      elem: this.DOM.cover,
      callback: (e)=>{
        if(e.direction == 'down') {
          this.moveToGrid()
        } else {
          this.moveToTop()
        }
      }
    });
    this.indicator.getOption('preventMouse');
  }

  finalize()
  {
      setTimeout(() => {
          if(Env.isVisiting === true) {
              this.intro()
          }
      }, 200);
  }

  prepareIntro()
  {
    gsap.set(this.DOM.title, { autoAlpha:0 })
    gsap.set(this.DOM.cta, { autoAlpha:0 })
  }

  intro()
  {

      const tl = gsap.timeline()

      tl.add([
        gsap.to(
          this.DOM.title,
          {
            autoAlpha:1,
            duration:1.2,
            ease:'cubic.inOut',
            delay:.3,
            onStart:()=>{
              this.slideshowIntro.Components.Autoplay.play()
            }
          }
        ),
        gsap.to(
          this.DOM.cta,
          {
            autoAlpha:1,
            duration:.8,
            delay:.5,
            ease:'cubic.inOut'
          }
        ),
        gsap.fromTo(
          this.DOM.slideshow,
          {
            autoAlpha:0,
            scale:1.05
          },
          {
            autoAlpha:1,
            scale:1,
            ease:'cubic.out',
            duration:1.5
          }
        )
      ])
      .add(()=>{

      })
  }

  makeSlideshow()
  {

    let checkLoad = 0
    const $slideshows = this.DOM.view.querySelectorAll('.jsSlideshow')
    const totalItems = $slideshows.length - 1
    for(let $slideshow of $slideshows) {
      const $splideView = $slideshow.querySelector('.jsSplide')
      const coordsSplide = $splideView.getBoundingClientRect()
      const $total = $slideshow.querySelector('.jsTotal')
      const $progress = $slideshow.querySelector('.jsProgress')
      const $firstSlide = $splideView.querySelectorAll('.jsItem')[0]
      const $firstSlideImg = $firstSlide.querySelector('img')

      // min height slideshow
      const ratioSplide =  $firstSlideImg.getAttribute('height') / $firstSlideImg.getAttribute('width')
      $splideView.style.maxHeight = `${(coordsSplide.width) *  ratioSplide}px`

      // Ratio Format
      const coords = $firstSlide.querySelector('img').getBoundingClientRect()
      let getRatio = coords.height / coords.width
      if(Env.mobileCSS == true && getRatio < .7) {
        getRatio = 1
        $splideView.classList.add('force-ratio')
      }

      // Make Slideshow
      const slideshow = new Splide($splideView , {
        arrows: false,
        type: 'fade',
        autoplay: false,
        interval: 1000,
        heightRatio: getRatio,
        rewind: true,
        pauseOnFocus:false,
        pauseOnHover:false,
        pagination:false,
        easing: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
        speed: 800
      })

      slideshow.on('mounted',()=>{
        if(totalItems == checkLoad) {
          // enableScroll()
        }

      })
      slideshow.mount()
      $total.innerHTML = slideshow.length
      $progress.innerHTML = slideshow.index + 1
      slideshow.on('move',()=>{
        $progress.innerHTML = slideshow.index + 1
      })
      this.slideshows.push(slideshow)
      $splideView.addEventListener('click',(e)=>{
        const coord = $splideView.getBoundingClientRect()
        if(e.offsetX > coord.width / 2) {
          slideshow.go('>')
        } else {
          slideshow.go('<')
        }
      })
      const getSlideshowHeight = slideshow.Components.Elements.track.getBoundingClientRect().height;
      $slideshow.querySelector('.features').style.top = `${getSlideshowHeight + 10}px`
      slideshow.on('resized',()=>{
        const getSlideshowHeight = slideshow.Components.Elements.track.getBoundingClientRect().height;
        $slideshow.querySelector('.features').style.top = `${getSlideshowHeight + 10}px`
      })
      checkLoad++
    }

  }

  makeSlideshowIntro()
  {
    this.slideshowIntro = new Splide(this.DOM.view.querySelector('.jsSlideshowIntro') , {
      arrows: false,
      type: 'fade',
      autoplay: true,
      interval: 2000,
      height:'calc(100vh - 220px)',
      rewind: true,
      pauseOnFocus:false,
      pauseOnHover:false,
      pagination:false,
      easing: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
      speed: 1000,
      breakpoints: {
        640: {
          height:'40%',
        }
      },
    }).mount()
    this.slideshowIntro.Components.Autoplay.pause()
  }

  moveToTop()
  {
    if(this.VARS.ANIMATING == false) {
      this.VARS.ANIMATING = true
      gsap.to(Env.$window, { scrollTo: { y : 0 } , ease: 'cubic.inOut' , duration: 1 ,onComplete:()=>{
          this.VARS.ANIMATING = false
        }
      })
    }

  }

  moveToGrid()
  {
    if(this.VARS.ANIMATING == false) {
      this.VARS.ANIMATING = true
      const viewport = Env.framework.toolbox.getViewport()
      gsap.to(Env.$window, { scrollTo: { y : viewport.height } , ease: 'cubic.inOut' , duration: 1, onComplete:()=>{
          this.VARS.ANIMATING = false
        }
      })
    }
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
    this.indicator.destroy()
    this.slideshowIntro.destroy(true)
    for(const slideshow of this.slideshows) {
      slideshow.destroy(true)
    }
  }
}
